module.exports = __webpack_public_path__ + "img/advertising-2.8973c088.png";